import { render, staticRenderFns } from "./UserBranchIndex.vue?vue&type=template&id=6750c75c"
import script from "./UserBranchIndex.vue?vue&type=script&lang=js"
export * from "./UserBranchIndex.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports